/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthStore } from '../store/auth';
import { FeedbackService } from '../services/feedback.service';

// Códigos de error relacionados con autenticación
const AUTH_ERROR_CODES = [
  'UnauthorizedUserAdminTokenExpired', // La sesión del administrador ha expirado
  'UnauthorizedUserAdmin', // Token de sesión no válido o no corresponde a sesión activa
  'UnauthorizedUserAdminToken', // Se requiere un token de sesión de administrador válido
];

interface ApiErrorResponse {
  code: string;
  message: string;
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private _router: Router,
    private _store: Store,
    private _feedService: FeedbackService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Verificar si es un error 401 y si contiene uno de los códigos de error específicos
        if (error.status === 401 && error.error) {
          const apiError = error.error as ApiErrorResponse;

          if (apiError.code && AUTH_ERROR_CODES.includes(apiError.code)) {
            // Dispatch de la acción logout para manejar la sesión de forma centralizada
            this._store.dispatch(AuthStore.actions.logout());

            // Redirigir al login
            if (apiError.message) {
              this._feedService.showError({ message: apiError.message, skipTranslation: false });
            }
            this._router.navigate(['/login']);
          }
        }

        // Re-lanzar el error para que otros lo manejen
        return throwError(() => error);
      })
    );
  }
}
